import * as React from "react"

import { formatTime24 } from "@/lib/time"
import { cn } from "@/lib/utils"

const Input = React.forwardRef(({ className, type, onChange, onBlur, ...props }, ref) => {
  const fieldClass = cn(
    "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-base shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 min-[1025px]:text-sm",
    className
  )
  if (type === "time") {
    return (
      <input
        {...props}
        type="text"
        inputMode="numeric"
        lang="en-GB"
        autoComplete="off"
        autoCorrect="off"
        spellCheck={false}
        placeholder={props.placeholder || "HH:MM"}
        pattern="(?:[01][0-9]|2[0-3]):[0-5][0-9]"
        title="Heure sur 24 heures, HH:MM"
        className={fieldClass}
        ref={ref}
        onChange={(event) => {
          const next = formatTime24(event.target.value, { partial: true })
          event.target.value = next
          onChange?.(event)
        }}
        onBlur={(event) => {
          const next = formatTime24(event.target.value)
          if (next !== event.target.value) {
            event.target.value = next
            onChange?.(event)
          }
          onBlur?.(event)
        }}
      />
    )
  }
  return (
    <input
      type={type}
      className={fieldClass}
      ref={ref}
      onChange={onChange}
      onBlur={onBlur}
      {...props} />
  );
})
Input.displayName = "Input"

export { Input }
